import { render } from "./MorePage.vue?vue&type=template&id=1ca7b6da&scoped=true"
const script = {}

import "./MorePage.vue?vue&type=style&index=0&id=1ca7b6da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ca7b6da"]])

export default __exports__